import { createContext, useContext } from "react";

/** A list-editable cell on its row: whether it edits here, why not, and its editor's open state. */
export interface ListCellState {
    access: "editable" | "readOnly";
    readOnlyReason: string | undefined;
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
    /** Closes the editor and focuses the cell, then runs `commit`. */
    closeAndCommit: (commit: () => void) => void;
}

/**
 * Provided by the grid's cell, so the column's memoized content follows the
 * editor's open state and the row's gate without redrawing; `null` outside
 * list-editable cells.
 */
export const ListCellContext = createContext<ListCellState | null>(null);

export const useListCellState = () => useContext(ListCellContext);

/**
 * Every cell of a list-editing table: focuses the cell, then runs `commit`,
 * as editors do, so a control outside any editor (a toggle in a label slot)
 * returns a confirmation's focus to its cell. `null` outside list tables.
 */
export const ListCellCommitContext = createContext<
    ((commit: () => void) => void) | null
>(null);
